import { string } from 'fp-ts';
import * as iots from 'io-ts';
export const logChildLabels = Symbol('labels');
export const logLevelsConfig = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
};
export const LogLevel = iots.keyof(logLevelsConfig);
/**
 * Merges a child context into a parent context
 *   - Merges labels into a single label
 *   - Overrides properties on the parent with properties from the child
 */
export const mergeChildContext = (parentContext) => (arg1, arg2) => {
    const parentLabels = parentContext[logChildLabels] ?? [];
    const [childLabel, childContext] = typeof arg1 === 'string' ? [arg1, arg2 ?? {}] : [undefined, arg1];
    return {
        ...parentContext,
        ...childContext,
        [logChildLabels]: [...parentLabels, childLabel].filter(string.isString),
    };
};
//# sourceMappingURL=domain.js.map